import ApiService from "../base/ApiService";

export async function apiSendErrorReport(data) {
    return ApiService.fetchData({
        url: '/core/frontend-app-errors/',
        method: 'post',
        data
    })
}
